import { vesselMetadataTypeParser } from "@pages/DatabasePage/plantMetadata/PlantMetadata"
import * as Tooltip from "@radix-ui/react-tooltip"
import { useAppDispatch } from "@redux/app/hooks"
import {
	setUnderConfigurationVessels,
	UnderConfigurationVesselsList,
} from "@redux/features/underConfigurationVessels/underConfigurationVesselsSlice"
import { PlantObject } from "api"
import { FC, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { MdSignalWifiStatusbarNotConnected } from "react-icons/md"

export type UnderConfigurationStatusIconProps = {
	colorTwString?: string
}

export const UnderConfigurationStatusIcon: FC<UnderConfigurationStatusIconProps> = ({
	// isAvailable,
	// lastTimestamp,
	colorTwString,
}) => {
	// couldnt replace this component for the Tooltip from the ui-lib. There is an error with reference to the positioning element... or something along this line
	// it has something to do with the asChild property
	const { t } = useTranslation()
	const [openTooltip, setOpenTooltip] = useState<boolean>(false)
	// let hovering = false
	const [clickOutsidePending, setClickOutsidePending] = useState(false)

	return (
		<Tooltip.Provider>
			<Tooltip.Root
				delayDuration={50}
				open={openTooltip}
			>
				<Tooltip.Trigger
					// asChild
					onClick={(e) => {
						e.stopPropagation()
						if (!clickOutsidePending) {
							setOpenTooltip(!openTooltip)
						}
						setClickOutsidePending(false)
					}}
					onMouseEnter={() => {
						// hovering = true
						setTimeout(() => {
							// if (hovering) {
							setOpenTooltip(true)
							// }
						}, 200)
					}}
					onMouseLeave={() => {
						// hovering = false
						setTimeout(() => {
							setOpenTooltip(false)
						}, 200)
					}}
				>
					<MdSignalWifiStatusbarNotConnected
						className={`h-5 w-5 cursor-help ${
							colorTwString !== undefined ? colorTwString : "text-slate-200"
						}`}
					/>
				</Tooltip.Trigger>
				<Tooltip.Portal>
					<Tooltip.Content
						className={`bg-dipai-secondary-800/85 z-10001 h-auto w-auto max-w-100 rounded-sm px-2 py-1 text-white/100`}
						sideOffset={5}
						side={`right`}
						onPointerDownOutside={(e) => {
							setOpenTooltip(false)
							setClickOutsidePending(true)
						}}
						onEscapeKeyDown={() => setOpenTooltip(false)}
					>
						<>
							<p>{t("VESSEL IS CURRENTLY UNDER CONFIGURATION")}</p>{" "}
							<p>{t("SOME/ALL PORTAL FEATURES MIGHT BE UNAVAILABLE")}</p>
						</>

						<Tooltip.Arrow className={`fill-dipai-secondary-800/85`} />
					</Tooltip.Content>
				</Tooltip.Portal>
			</Tooltip.Root>
		</Tooltip.Provider>
	)
}

export function useGetUnderConfigurationVessels(customerPlants: {
	[plantName: string]: PlantObject
}) {
	const dispatch = useAppDispatch()

	useEffect(() => {
		const underConfigurationVesselsTemp: UnderConfigurationVesselsList = []
		Object.entries(customerPlants).forEach(([plantName, plantData]) => {
			try {
				const plantMetaDataParsed = vesselMetadataTypeParser.parse(plantData.metaData)
				const isUnderConfiguration = plantMetaDataParsed.isUnderConfiguration
				if (isUnderConfiguration !== true) {
					return
				}
			} catch (e) {
				return
			}
			underConfigurationVesselsTemp.push({
				id: plantData.id,
				name: plantName,
			})
		})

		dispatch(setUnderConfigurationVessels(underConfigurationVesselsTemp))
	}, [customerPlants])
}
